import { isNumber } from 'lodash'
import Vue from 'vue'

import config from '@/config'
import uuid from '@/util/uuid'

export default new Vue({

  data () {
    return {
      overlayTitle: null,
      overlayTitleTimer: null,
      stack: []
    }
  },

  computed: {

    currentNotification () {
      return this.stack.length ? this.stack[this.stack.length - 1] : null
    }
  },

  watch: {

    overlayTitle (newTitle) {
      if (newTitle) {
        if (this.overlayTitleTimer) {
          clearTimeout(this.overlayTitleTimer)
        }

        this.overlayTitleTimer = setTimeout(() => {
          this.overlayTitle = null
        }, config.overlayTitleDelay)
      }
    }

  },

  methods: {

    closeById (id) {
      const i = find(this.stack, (notification) => {
        return notification.id === id
      })

      if (isNumber(i)) {
        this.closeOne(i)
      }
    },

    closeOne (i) {
      this.stack.splice(i, 1)
    },

    closeLast () {
      this.stack.shift()
    },

    open (message) {
      const id = uuid()

      this.stack.push({
        id,
        message
      })

      setTimeout(this.closeLast, config.notificationDelay)
    }

  }

})
